import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "crumbs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "企业资料库", -1)
const _hoisted_5 = {
  key: 1,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataHead = _resolveComponent("DataHead")!
  const _component_DataLeft = _resolveComponent("DataLeft")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_DataFoot = _resolveComponent("DataFoot")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataHead),
    (!_ctx.$route.meta.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_DataLeft),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" > " + _toDisplayString(_ctx.$route.meta.title), 1)
            ]),
            _createVNode(_component_router_view)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$route.meta.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DataFoot)
  ], 64))
}